import { render, staticRenderFns } from "./LeadFollowUp.vue?vue&type=template&id=61cf5750&scoped=true&"
import script from "./LeadFollowUp.vue?vue&type=script&lang=js&"
export * from "./LeadFollowUp.vue?vue&type=script&lang=js&"
import style0 from "./LeadFollowUp.vue?vue&type=style&index=0&id=61cf5750&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf5750",
  null
  
)

export default component.exports